/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../request'
// @ts-ignore
import makeRequestHook from '../makeRequestHook'

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig
}

const mockUrl_0_0_0_0 = 'http://127.0.0.1:50505/mock/0' as any
const devUrl_0_0_0_0 = '' as any
const prodUrl_0_0_0_0 = '' as any
const dataKey_0_0_0_0 = 'data' as any

/**
 * 接口 编辑收款账号信息 的 **请求类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/savePayee`
 */
export interface PostSavePayeeRequest {
  /**
   * 供应商id
   */
  supply_id: string
  /**
   * 收款人姓名
   */
  payee_name: string
  /**
   * 开户行名称
   */
  payee_bank: string
  /**
   * 账号
   */
  payee_bank_account: string
  /**
   * 收款银行支行
   */
  cnap: string
  /**
   * 收款账号id (新增操作无需传这个参数)
   */
  payee_id?: string
  /**
   * 是否默认 0 否 1是
   */
  is_default?: string
}

/**
 * 接口 编辑收款账号信息 的 **返回类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/savePayee`
 */
export interface PostSavePayeeResponse {}

/**
 * 接口 编辑收款账号信息 的 **请求配置的类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/savePayee`
 */
type PostSavePayeeRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/baob/SupplyPayee/savePayee', 'data', string, string, false>
>

/**
 * 接口 编辑收款账号信息 的 **请求配置**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/savePayee`
 */
const postSavePayeeRequestConfig: PostSavePayeeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/baob/SupplyPayee/savePayee',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'postSavePayee',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 编辑收款账号信息 的 **请求函数**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/savePayee`
 */
export const postSavePayee = /*#__PURE__*/ (requestData: PostSavePayeeRequest, ...args: UserRequestRestArgs) => {
  return request<PostSavePayeeResponse>(prepare(postSavePayeeRequestConfig, requestData), ...args)
}

postSavePayee.requestConfig = postSavePayeeRequestConfig

/**
 * 接口 编辑收款账号信息 的 **React Hook**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/savePayee`
 */
export const usePostSavePayee = /*#__PURE__*/ makeRequestHook<
  PostSavePayeeRequest,
  PostSavePayeeRequestConfig,
  ReturnType<typeof postSavePayee>
>(postSavePayee)

/**
 * 接口 删除收款账号信息 的 **请求类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/remove`
 */
export interface PostRemoveRequest {
  /**
   * 商家ID
   */
  supply_id?: string
  /**
   * 收款账号信息ID
   */
  payee_id?: string
}

/**
 * 接口 删除收款账号信息 的 **返回类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/remove`
 */
export interface PostRemoveResponse {}

/**
 * 接口 删除收款账号信息 的 **请求配置的类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/remove`
 */
type PostRemoveRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/baob/SupplyPayee/remove', 'data', string, string, false>
>

/**
 * 接口 删除收款账号信息 的 **请求配置**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/remove`
 */
const postRemoveRequestConfig: PostRemoveRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/baob/SupplyPayee/remove',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'postRemove',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 删除收款账号信息 的 **请求函数**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/remove`
 */
export const postRemove = /*#__PURE__*/ (requestData: PostRemoveRequest, ...args: UserRequestRestArgs) => {
  return request<PostRemoveResponse>(prepare(postRemoveRequestConfig, requestData), ...args)
}

postRemove.requestConfig = postRemoveRequestConfig

/**
 * 接口 删除收款账号信息 的 **React Hook**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/remove`
 */
export const usePostRemove = /*#__PURE__*/ makeRequestHook<
  PostRemoveRequest,
  PostRemoveRequestConfig,
  ReturnType<typeof postRemove>
>(postRemove)

/**
 * 接口 获取全部收款账号 的 **请求类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getAllPayee`
 */
export interface PostGetAllPayeeRequest {
  /**
   * 商家ID
   */
  supply_id?: string
}

/**
 * 接口 获取全部收款账号 的 **返回类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getAllPayee`
 */
export type PostGetAllPayeeResponse = {
  payee_id: string
  supply_id: string
  payee_name: string
  payee_bank: string
  payee_bank_account: string
  is_default: string
  cnap_name: string
  cnap: string
  auth_status: string
  icon: string
  background: string
  notice: string
}[]

/**
 * 接口 获取全部收款账号 的 **请求配置的类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getAllPayee`
 */
type PostGetAllPayeeRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/baob/SupplyPayee/getAllPayee', 'data', string, string, false>
>

/**
 * 接口 获取全部收款账号 的 **请求配置**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getAllPayee`
 */
const postGetAllPayeeRequestConfig: PostGetAllPayeeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/baob/SupplyPayee/getAllPayee',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'postGetAllPayee',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取全部收款账号 的 **请求函数**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getAllPayee`
 */
export const postGetAllPayee = /*#__PURE__*/ (requestData: PostGetAllPayeeRequest, ...args: UserRequestRestArgs) => {
  return request<PostGetAllPayeeResponse>(prepare(postGetAllPayeeRequestConfig, requestData), ...args)
}

postGetAllPayee.requestConfig = postGetAllPayeeRequestConfig

/**
 * 接口 获取全部收款账号 的 **React Hook**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getAllPayee`
 */
export const usePostGetAllPayee = /*#__PURE__*/ makeRequestHook<
  PostGetAllPayeeRequest,
  PostGetAllPayeeRequestConfig,
  ReturnType<typeof postGetAllPayee>
>(postGetAllPayee)

/**
 * 接口 获取银行 的 **请求类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getBank`
 */
export interface PostGetBankRequest {
  /**
   * 银行名称（模糊搜索）
   */
  bank?: string
}

/**
 * 接口 获取银行 的 **返回类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getBank`
 */
export interface PostGetBankResponse {
  banks: {
    bank: string
    icon: string
  }[]
}

/**
 * 接口 获取银行 的 **请求配置的类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getBank`
 */
type PostGetBankRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/baob/SupplyPayee/getBank', 'data', string, string, false>
>

/**
 * 接口 获取银行 的 **请求配置**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getBank`
 */
const postGetBankRequestConfig: PostGetBankRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/baob/SupplyPayee/getBank',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'postGetBank',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取银行 的 **请求函数**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getBank`
 */
export const postGetBank = /*#__PURE__*/ (requestData: PostGetBankRequest, ...args: UserRequestRestArgs) => {
  return request<PostGetBankResponse>(prepare(postGetBankRequestConfig, requestData), ...args)
}

postGetBank.requestConfig = postGetBankRequestConfig

/**
 * 接口 获取银行 的 **React Hook**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getBank`
 */
export const usePostGetBank = /*#__PURE__*/ makeRequestHook<
  PostGetBankRequest,
  PostGetBankRequestConfig,
  ReturnType<typeof postGetBank>
>(postGetBank)

/**
 * 接口 获取支行 的 **请求类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getCnap`
 */
export interface PostGetCnapRequest {
  /**
   * 银行名称（模糊搜索）
   */
  bank?: string
  /**
   * 支行名称
   */
  cnap_name?: string
}

/**
 * 接口 获取支行 的 **返回类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getCnap`
 */
export type PostGetCnapResponse = {
  cnap: string
  cnap_name: string
}[]

/**
 * 接口 获取支行 的 **请求配置的类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getCnap`
 */
type PostGetCnapRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/baob/SupplyPayee/getCnap', 'data', string, string, false>
>

/**
 * 接口 获取支行 的 **请求配置**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getCnap`
 */
const postGetCnapRequestConfig: PostGetCnapRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/baob/SupplyPayee/getCnap',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'postGetCnap',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取支行 的 **请求函数**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getCnap`
 */
export const postGetCnap = /*#__PURE__*/ (requestData: PostGetCnapRequest, ...args: UserRequestRestArgs) => {
  return request<PostGetCnapResponse>(prepare(postGetCnapRequestConfig, requestData), ...args)
}

postGetCnap.requestConfig = postGetCnapRequestConfig

/**
 * 接口 获取支行 的 **React Hook**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/getCnap`
 */
export const usePostGetCnap = /*#__PURE__*/ makeRequestHook<
  PostGetCnapRequest,
  PostGetCnapRequestConfig,
  ReturnType<typeof postGetCnap>
>(postGetCnap)

/**
 * 接口 平安协议签署 的 **请求类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/agreement`
 */
export interface PostAgreementRequest {
  /**
   * 逗号分隔
   */
  supply_ids?: string
  /**
   * IP地址
   */
  ip?: string
  /**
   * MAC地址
   */
  mac?: string
  /**
   * 爆版用户ID
   */
  baob_user_id?: string
  /**
   * 爆版用户昵称
   */
  baob_user_name?: string
  /**
   * 爆版店铺主账号手机号码
   */
  baob_mobile_phone?: string
}

/**
 * 接口 平安协议签署 的 **返回类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/agreement`
 */
export interface PostAgreementResponse {
  is_authentication: number
}

/**
 * 接口 平安协议签署 的 **请求配置的类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/agreement`
 */
type PostAgreementRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/baob/SupplyPayee/agreement', 'data', string, string, false>
>

/**
 * 接口 平安协议签署 的 **请求配置**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/agreement`
 */
const postAgreementRequestConfig: PostAgreementRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/baob/SupplyPayee/agreement',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'postAgreement',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 平安协议签署 的 **请求函数**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/agreement`
 */
export const postAgreement = /*#__PURE__*/ (requestData: PostAgreementRequest, ...args: UserRequestRestArgs) => {
  return request<PostAgreementResponse>(prepare(postAgreementRequestConfig, requestData), ...args)
}

postAgreement.requestConfig = postAgreementRequestConfig

/**
 * 接口 平安协议签署 的 **React Hook**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/agreement`
 */
export const usePostAgreement = /*#__PURE__*/ makeRequestHook<
  PostAgreementRequest,
  PostAgreementRequestConfig,
  ReturnType<typeof postAgreement>
>(postAgreement)

/**
 * 接口 平安签约协议检查 的 **请求类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/checkPingan`
 */
export interface PostCheckPinganRequest {
  /**
   * 商家
   */
  supply_id?: string
  /**
   * 爆版手机号
   */
  baob_mobile_phone?: string
}

/**
 * 接口 平安签约协议检查 的 **返回类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/checkPingan`
 */
export interface PostCheckPinganResponse {
  is_sign_pingan_agreement: number
  is_authentication: number
  need_sign_supply_id: string
  can_sign_account: number
}

/**
 * 接口 平安签约协议检查 的 **请求配置的类型**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/checkPingan`
 */
type PostCheckPinganRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/baob/SupplyPayee/checkPingan', 'data', string, string, false>
>

/**
 * 接口 平安签约协议检查 的 **请求配置**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/checkPingan`
 */
const postCheckPinganRequestConfig: PostCheckPinganRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/baob/SupplyPayee/checkPingan',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'postCheckPingan',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 平安签约协议检查 的 **请求函数**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/checkPingan`
 */
export const postCheckPingan = /*#__PURE__*/ (requestData: PostCheckPinganRequest, ...args: UserRequestRestArgs) => {
  return request<PostCheckPinganResponse>(prepare(postCheckPinganRequestConfig, requestData), ...args)
}

postCheckPingan.requestConfig = postCheckPinganRequestConfig

/**
 * 接口 平安签约协议检查 的 **React Hook**
 *
 * @分类 商家
 * @请求头 `POST /baob/SupplyPayee/checkPingan`
 */
export const usePostCheckPingan = /*#__PURE__*/ makeRequestHook<
  PostCheckPinganRequest,
  PostCheckPinganRequestConfig,
  ReturnType<typeof postCheckPingan>
>(postCheckPingan)

/* prettier-ignore-end */
